import React from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IElementQuestionnaire} from '../../../../incase-domain/elements/base/questionElementBase';
import {getBorderStyle} from '../../../../utils/style.utils';
import ConfirmButton from './ConfirmButton';
import QuestionTitle from './QuestionTitle';
import QuestionCounter from './QuestionCounter';
import ResultsButton from './ResultsButton';

interface QuestionLayoutProps {
    element: IElementQuestionnaire;
    device?: DeviceType;
    showConfirmButton?: boolean;
    children?: React.ReactNode;
    hideCounter?: boolean;
    isAnswered?: boolean;
    isActive?: boolean;
}

function QuestionLayout(props: QuestionLayoutProps): JSX.Element {
    const {
        element,
        device = DeviceType.DESKTOP,
        showConfirmButton,
        children,
        isAnswered = false,
        isActive = false,
        hideCounter = false,
    } = props;
    const {questionBackgroundColor, questionBackgroundBorderRadius} = element;

    return (
        <div
            className={`c-questionLayout ${device === DeviceType.MOBILE && 'c-questionLayout--mobile'} ${isActive && 'is-active'} ${
                isAnswered && 'is-answered'
            }`}
            style={{
                backgroundColor: questionBackgroundColor,
                borderRadius: getBorderStyle(questionBackgroundBorderRadius),
            }}
        >
            {element.isDebatable && <div className="c-questionLayout__ribbon">debate</div>}
            <div className="c-questionLayout__header">
                <QuestionTitle element={element} device={device} />
                {!hideCounter && <QuestionCounter element={element} />}
            </div>
            <div className="c-questionLayout__body">{children}</div>
            <div className="c-questionLayout__footer">
                {showConfirmButton && device === DeviceType.DESKTOP && <ConfirmButton element={element} />}
                {element.showResults && <ResultsButton device={device} element={element} />}
            </div>
        </div>
    );
}

export default QuestionLayout;
